(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sp-navigation-ui"] && !Shopify.designMode) return;
  try {
    (() => {
    const normalize = (text) => text.toLocaleLowerCase('nl').normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-z0-9 ]/g,' ').replace(/\s+/g,' ').trim();
    const distance = (a,b) => {
      if (Math.abs(a.length-b.length)>1) return 2;
      let previous=Array.from({length:b.length+1},(_,i)=>i);
      for(let i=1;i<=a.length;i++) {
        const row=[i];
        for(let j=1;j<=b.length;j++) row[j]=Math.min(row[j-1]+1,previous[j]+1,previous[j-1]+(a[i-1]===b[j-1]?0:1));
        previous=row;
      }
      return previous[b.length];
    };
    function source() {
      try {return JSON.parse(document.getElementById('sp-navigation-index')?.textContent||'{"items":[]}');}
      catch {return {items:[]};}
    }
    function matches(term) {
      const q=normalize(term);if(q.length<2||/^(pepe|supplier|import test)/.test(q)) return [];
      const words=q.split(' ');const seen=new Set();
      return source().items.map(item=>{
        const title=normalize(item.title);const searchable=title+' '+normalize(item.group);
        let score=words.every(w=>searchable.includes(w))?(title===q?100:title.startsWith(q)?80:60):0;
        if(!score&&words.length===1&&q.length>=5&&title.split(' ').some(w=>distance(q,w)<=1)) score=30;
        return {...item,score};
      }).filter(item=>item.score>0).sort((a,b)=>b.score-a.score).filter(item=>{if(seen.has(item.url))return false;seen.add(item.url);return true;}).slice(0,5);
    }
    function link(item) {
      const a=document.createElement('a');a.href=item.url;a.textContent=item.title;return a;
    }
    function addSuggestions(root,term) {
      const found=matches(term);const listbox=root.querySelector('[role="listbox"]');
      if(!listbox||!found.length)return;
      const section=document.createElement('div');section.className='sp-search-categories';
      const heading=document.createElement('h2');heading.id='sp-category-heading';heading.textContent=source().heading;section.append(heading);
      const list=document.createElement('ul');list.setAttribute('role','group');list.setAttribute('aria-labelledby',heading.id);
      found.forEach((item,i)=>{const li=document.createElement('li');li.id='sp-category-option-'+i;li.setAttribute('role','option');li.setAttribute('aria-selected','false');const a=link(item);a.tabIndex=-1;const small=document.createElement('small');small.textContent=item.group;a.append(small);li.append(a);list.append(li);});
      section.append(list);listbox.prepend(section);
    }
    window.ScyptoNavigation={matches,addSuggestions};
    function enhance(scope) {
      scope.querySelectorAll('[data-sp-directory]').forEach(directory=>{
        if(directory.dataset.ready)return;directory.dataset.ready='true';
        const input=directory.querySelector('input');const items=Array.from(directory.querySelectorAll('[data-sp-type]'));const empty=directory.querySelector('[data-sp-empty]');
        input.addEventListener('input',()=>{const q=normalize(input.value);let count=0;for(const item of items){item.hidden=!normalize(item.textContent).includes(q);if(!item.hidden)count++;}empty.hidden=count>0;});
      });
      scope.querySelectorAll('[data-sp-search-categories]').forEach(container=>{
        const query=container.dataset.query;const found=matches(query);const list=container.querySelector('.sp-search-category-links');
        list.replaceChildren(...found.map(item=>{const a=link(item);a.className='sp-chip';return a;}));
      });
    }
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>enhance(document));else enhance(document);
    document.addEventListener('shopify:section:load',event=>enhance(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
